import React, { PureComponent } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import Login from './containers/Login'
import SwitchApp from './containers/SwitchApp'
import { isLoggedIn } from './utils/api'
import Settings from './containers/Settings'
import ResetPassword from './containers/ResetPassword'
import Reset from './containers/Reset'
import Recover from './containers/Recover'
import InvitationVerification from './containers/InvitationVerification'
import ThankYou from './containers/ThankYou'
import { renewSession } from './actions/auth'
import qs from 'query-string'
import { connect } from 'react-redux'
import { redirectToBlazeInsights } from './actions/insights'
import GraphQL from './containers/GraphQL'
import ApolloRoute from './graphql/ApolloRoute'
import { ProtectedRoute } from './components/Auth/ProtectedRoute'
import { validateFeatureBranchUrl } from './utils/validateFeatureBranch'
import { LocalStorage } from './utils/localStorage'

const checkAuth = () => {
  return isLoggedIn()
}

const params = qs.parse(window.location.search)
const current = params['current'] || ''

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { match = {} } = props
      const { params = {} } = match

      if (window.Appcues) {
        window.Appcues.start()
        window.Appcues.page()
      }

      if (checkAuth()) {
        //specific case, all other apps need to pass through switch-app api
        if (params.app == 'INSIGHTS') {
          rest.dispatch(redirectToBlazeInsights()).then((url) => {
            if (url) {
              window.location.replace(url)
              return
            }
          })
        }
        return <Redirect to={{ pathname: `/${current ? current : 'switch'}` }} />
      } else {
        return <Component {...props} />
      }
    }}
  />
)

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (window.Appcues) {
        window.Appcues.start()
        window.Appcues.page()
      }
      return checkAuth() ? <Component {...props} /> : <Redirect to={{ pathname: `/` }} />
    }}
  />
)

const RedirectTo = (path) => (props) => <Redirect to={path} />

class Routes extends PureComponent {
  constructor(props) {
    super(props)
    const searchParams = window.location.search
    const queryParams = qs.parse(searchParams)
    const { token } = queryParams

    if (isLoggedIn()) {
      if (token) {
        let tokenStr = token.split(' ').join('+')
        let newSession = window.localStorage.getObject('session')
        newSession.accessToken = tokenStr
        window.localStorage.saveObject('session', newSession)
        this.props.dispatch(renewSession({ Authorization: `Token ${tokenStr}` })).then((res) => {
          window.localStorage.setItem('returnShopId', res.assignedShop && res.assignedShop.id)
        })
      }

      if (queryParams.fbUrl) {
        const isFeatureBranchUrlValid = validateFeatureBranchUrl(queryParams.fbUrl)
        if (!isFeatureBranchUrlValid) return

        LocalStorage.setFeatureBranchUrl(queryParams.fbUrl)
        if (!queryParams.return) window.location.href = queryParams.fbUrl
      }

      if (queryParams.return) {
        window.localStorage.setItem('returnUrl', queryParams.return)
      }
    }
  }

  async componentDidMount() {
    if (window.Appcues) {
      window.Appcues.start()
      window.Appcues.page()
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <PublicRoute exact path="/" component={Login} />
          <PublicRoute exact path="/redirect/:app" component={Login} {...this.props} />
          <PublicRoute path="/password/recovery" component={ResetPassword} />
          <PublicRoute path="/reset" component={Reset} />
          <PublicRoute path="/recover" component={Recover} />
          <PublicRoute path="/employeesignup" component={InvitationVerification} />
          <PublicRoute path="/thankyou" component={ThankYou} />
          <PrivateRoute path="/switch" component={SwitchApp} />
          <ProtectedRoute path="/settings" component={Settings} />
          <ApolloRoute path="/graphql" component={GraphQL} />
          <PublicRoute component={RedirectTo('/')} />
        </Switch>
      </BrowserRouter>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  authReducer: state.auth,
}))(Routes)



// WEBPACK FOOTER //
// ./src/Routes.js